<script setup>
import { useI18n } from 'vue-i18n';
import NextInput from 'dashboard/components-next/input/Input.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const attributes = defineModel({ type: Array, required: true });

const { t } = useI18n();

const removeAttribute = index => {
  attributes.value = attributes.value.filter((_, i) => i !== index);
};

const addAttribute = () => {
  attributes.value = [
    ...attributes.value,
    {
      attribute_display_name: '',
      attribute_key: '',
      attribute_display_type: 'text',
      attribute_model: 'contact_attribute',
    },
  ];
};

const slugifyKey = name =>
  name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');

const handleNameInput = attribute => {
  attribute.attribute_key = slugifyKey(attribute.attribute_display_name);
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <p class="text-sm text-n-slate-11">
      {{ t('QUICK_SETUP.STEP_ATTRIBUTES.DESCRIPTION') }}
    </p>

    <div class="flex flex-col gap-2">
      <div
        v-for="(attribute, index) in attributes"
        :key="index"
        class="flex items-center gap-2"
      >
        <NextInput
          v-model="attribute.attribute_display_name"
          type="text"
          class="w-full"
          :placeholder="t('QUICK_SETUP.STEP_ATTRIBUTES.NAME_PLACEHOLDER')"
          @input="handleNameInput(attribute)"
        />
        <button
          type="button"
          class="i-lucide-trash-2 size-4 text-n-ruby-9 shrink-0"
          @click="removeAttribute(index)"
        />
      </div>
    </div>

    <NextButton
      variant="faded"
      color="slate"
      size="sm"
      type="button"
      class="w-fit"
      icon="i-lucide-plus"
      :label="t('QUICK_SETUP.STEP_ATTRIBUTES.ADD_ATTRIBUTE')"
      @click="addAttribute"
    />
  </div>
</template>
